@if (answers()?.length) {
	<table class="answers-table">
		<thead>
			<tr>
				<th class="answers-col-q">Pytanie</th>
				<th class="answers-col-a">Odpowiedź</th>
			</tr>
		</thead>
		<tbody>
			@for (answer of orderedAnswers(); track answer.answerId) {
				<tr>
					<td class="answers-col-q">{{ answer | questionLabel }}</td>
					<td class="answers-col-a">
						@if (answer.answer | isScanAnswer) {
							<div class="scan-answer">
								@if (answer.scan; as scan) {
									<button
										type="button"
										class="scan-badge scan-badge--link"
										[disabled]="previewLoadingId() === scan.id"
										matTooltip="Otwórz podgląd skanu"
										(click)="openScanPreview(scan)"
									>
										<mat-icon>
											@if (previewLoadingId() === scan.id) {
												<i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
											} @else {
												<i class="fa-solid fa-image" aria-hidden="true"></i>
											}
										</mat-icon>
										<span>Skan</span>
									</button>
									<span class="scan-token">{{ answer.answer }}</span>
									<app-scan-status-badges
										[ocrStatus]="scan.ocrStatus"
										[costStatus]="scan.costStatus"
										[archiveStatus]="scan.archiveStatus"
									/>
								} @else {
									<span
										class="scan-badge scan-badge--muted"
										matTooltip="Skan niedostępny w module skanów"
									>
										<mat-icon><i class="fa-solid fa-image" aria-hidden="true"></i></mat-icon>
										<span>Skan</span>
									</span>
									<span class="scan-token">{{ answer.answer }}</span>
								}
							</div>
						} @else {
							{{ answer.answer || '—' }}
						}
					</td>
				</tr>
			}
		</tbody>
	</table>

	@for (scan of decisionScans(); track scan.id) {
		<div class="decision-bar">
			<span class="decision-label">Decyzja</span>
			<div class="decision-actions">
				@for (opt of decisionOptions; track opt.value) {
					<button
						type="button"
						class="decision-action"
						[class.is-active]="scan.costStatus === opt.value"
						[attr.data-status]="opt.value"
						[disabled]="busyScanId() === scan.id || scan.costStatus === opt.value"
						(click)="setDecision(scan, opt.value)"
					>
						<mat-icon><i class="fa-solid {{ opt.icon }}" aria-hidden="true"></i></mat-icon>
						<span>{{ opt.label }}</span>
					</button>
				}
			</div>

			@if (busyScanId() === scan.id) {
				<mat-icon class="decision-spin" aria-hidden="true"
					><i class="fa-solid fa-spinner fa-spin"></i
				></mat-icon>
			}

			@if (scan.driverLedgerEntryId !== null) {
				<span class="decision-ledger decision-ledger--linked" role="status">
					<mat-icon><i class="fa-solid fa-circle-check" aria-hidden="true"></i></mat-icon>
					<span>W kasie — wpis #{{ scan.driverLedgerEntryId }}</span>
				</span>
			} @else if (scan.costStatus === 'confirmed' && openFormScan()?.id !== scan.id) {
				<button
					type="button"
					class="decision-ledger-btn"
					[disabled]="busyScanId() === scan.id"
					matTooltip="Utwórz wpis w księdze kierowcy"
					(click)="openLedgerForm(scan)"
				>
					<mat-icon><i class="fa-solid fa-book" aria-hidden="true"></i></mat-icon>
					<span>Dodaj do kasy</span>
				</button>
			}
		</div>

		@if (scanErrors()[scan.id]; as err) {
			<p class="decision-error" role="alert">{{ err }}</p>
		}

		@if (openFormScan(); as formScan) {
			@if (formScan.id === scan.id) {
				<app-scan-ledger-form
					[scan]="formScan"
					[driverId]="driverId()"
					[suggestedAmount]="costHints().amount"
					[suggestedCurrency]="costHints().currency"
					(posted)="onLedgerPosted($event)"
					(cancelled)="onLedgerCancelled()"
				/>
			}
		}
	}
} @else {
	<p class="answers-empty">Brak zapisanych odpowiedzi.</p>
}
